import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Statuses, Task} from 'app/entities/Task';
import {TaskService} from '../../services/task.service';
import {SalesPersonService} from '../../services/sales-person.service';
import {Responsible} from '../../entities/SalesPerson'
import {TaskFilterModel} from '../../entities/filter-models/TaskFilterModel';
import {Job} from '../../entities/Job';
import {JobService} from '../../services/job.service';
import {subscribeOn} from 'rxjs/operator/subscribeOn';
import {CommunicationLog} from '../../entities/CommunicationLog';
import {AppFile} from '../../entities/AppFile';
import {forEach} from '@angular/router/src/utils/collection';
import {debug} from 'util';
import {CreateTaskWithFiles} from '../../entities/CreateTaskWithFiles';

declare var $: any;

@Component({
  selector: 'app-task-administration-view',
  templateUrl: './task-administration-view.component.html',
  styleUrls: ['./task-administration-view.component.css']
})
export class TaskAdministrationViewComponent implements OnInit {

  public _communicationLogs: CommunicationLog[] = [];
  public _tasks: Task[];
  public _salesPersons: Responsible[];
  public _jobs: Job[];
  public chosenTask: Task;
  editTaskOpen: boolean = false;
  createTaskOpen: boolean = false;

  searchBar: any;

  searchInput: string = '';
  filterInput: TaskFilterModel = new TaskFilterModel();

  orderParameter: string;
  sortReverse: boolean;
  loading: boolean;
  filesToDownload: AppFile[] = [];
  filesToUpload: AppFile[] = [];
  doneLoading: boolean;

  statuses = Statuses;
  keys: any;
  inputCommunicationLog: string = '';

  @Output()
  uploadFilesEmitter = new EventEmitter();
  @Output()
  downloadFileEmitter = new EventEmitter();
  @Output()
  fetchCommunicationLogsEmitter = new EventEmitter();
  @Output()
  createCommunicationLogEmitter = new EventEmitter();
  @Output()
  updateTaskEmitter = new EventEmitter();
  @Output()
  createTaskEmitter = new EventEmitter();
  @Output()
  filterTaskEmitter = new EventEmitter();
  @Output()
  refreshTaskEmitter = new EventEmitter();
  @Output()
  showTaskDetailsEmitter = new EventEmitter();
  @Output()
  showCreateTaskEmitter = new EventEmitter();

  @Input('DoneLoading')
  set DoneLoading(loading: boolean) {
    this.doneLoading = loading;
  }

  @Input('FilesToDownload')
  set files(files: AppFile[]) {
    this.filesToDownload = files;
  }


  @Input('Loading')
  set Loading(value: boolean) {
    this.loading = value;
  }

  @Input('chosenTask')
  set Task(task: Task) {
    this.chosenTask = task;
  }

  @Input('Tasks')
  set Tasks(value: Task[]) {
    this._tasks = value;
  }

  @Input('salesPersons')
  set salesPersons(value: Responsible[]) {
    this._salesPersons = value;
  }

  @Input('Jobs')
  set Job(value: Job[]) {
    this._jobs = value;
  }

  @Input('CommunicationLogs')
  set CommunicationLogs(value: CommunicationLog[]) {
    this._communicationLogs = value;
  }

  constructor(private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.setOrderParameter('No');
    this.keys = Object.keys(this.statuses).filter(k => !isNaN(Number(k)));
    window.addEventListener('keydown', (ev => {
      if (ev.keyCode == 27) {
        this.searchInput = '';
      }
    }));
  }

  setOrderParameter(para: string) {
    if (this.orderParameter == para) {
      this.sortReverse = !this.sortReverse;
    }
    this.orderParameter = para;
  }


  showTaskDetails(task: Task) {
    //console.log(task.TaskGUID);
    //this.salesPersonService.getAllSalesPersonsAsSalesPerson().subscribe(salesPeople => this.salesPersons = salesPeople
    this.editTaskOpen = true;
    this.changeDetectorRef.detach();
    this.showTaskDetailsEmitter.emit(task);
    setTimeout(() => {

      $('#myModal').modal('show');
    }, 50);
    setInterval(() => {
      this.changeDetectorRef.detectChanges();
    }, 500);
  }

  updateTask(task: Task) {
    this.updateTaskEmitter.emit(task);
  }

  showCreateTask() {
    this.createTaskOpen = true;
    this.showCreateTaskEmitter.emit();
    setTimeout(() => {
      $('#createModal').modal('show');
    }, 50);
  }

  createTask(taskToCreate: CreateTaskWithFiles) {
    this.createTaskEmitter.emit(taskToCreate);
  }

  filterUpdated() {
    this.filterTaskEmitter.emit(this.filterInput);
    console.log(this._tasks);

    //console.log(this.filterInput)
  }

  refreshTasks(_tasks) {
    this.refreshTaskEmitter.emit(_tasks);
  }

  /*getPage(pageIndex: number) {
    this.filterInput.pageNo = pageIndex;
    this.filterInput.pageSize = 10;
    this.filterUpdated();
  }*/
  createCommunicationLog(note: string) {
    this.createCommunicationLogEmitter.emit(note);
  }

  uploadFiles(files: AppFile[]) {
    this.uploadFilesEmitter.emit(files);
  }

  downloadFile(file) {
    this.downloadFileEmitter.emit(file);
  }

  taskConfigs(task: Task): string {
    let arrayTask = [];
    if ((task.No == '')) {
      arrayTask.push('No');
    }
    if ((task.Deadline == '0001-01-01T00:00:00')) {
      arrayTask.push('Deadline');
    }
    if ((task.Customer_Name == '')) {
      arrayTask.push(' Customer Name');
    }
    if ((task.To_Be_Done_By == '')) {
      arrayTask.push('To Be Done By');
    }
    if ((task.JobNo == '')) {
      arrayTask.push('Job No');
    }
    if ((task.Status == '')) {
      arrayTask.push('Status');
    }
    if ((task.Job_Description == '')) {
      arrayTask.push('Job Description');
    }
    if ((task.Job_Task_No == '')) {
      arrayTask.push('Job Task No');
    }
    if ((task.Responsible == '')) {
      arrayTask.push('Responsible');
    }
    if ((task.Estimate == 0)) {
      arrayTask.push('Estimated Hours');
    }

    let newStr: string = '';
    arrayTask.forEach(str => {
      if (arrayTask.indexOf(str) == 0) {
        newStr = str;
      } else if (arrayTask.indexOf(str) == arrayTask.length - 1) {
        newStr = newStr + '<br>' + str;
      } else {
      }
    });
    return newStr;
  }

  isTaskFinished(task: Task): boolean {
    if ((this.taskConfigs(task) == '')) {
      return true;
    }
    return false;
  }

  taskDeadlineIsExceeded(task: Task): string {
    let date = new Date();

    let newDate = new Date(task.Deadline);
    if(task.Status == 'Udført'){
      return 'isCompleted';
    }else if (task.Deadline == '0001-01-01T00:00:00') {
      return 'isNotExceeded';
    } else if (newDate < date) {
      return 'IsExceeded';
    } else if (this.isDateSoon(newDate)) {
      return 'isAlmostExpired';
    }
    return 'isNotExceeded';
  }

  checkingMarker(task: Task): boolean {
    if (this.taskDeadlineIsExceeded(task)) {
      return true;
    } else {
      return false;
    }

  }

  isDateSoon(taskDate: Date): boolean {
    let today = new Date();
    if (taskDate.getFullYear() == today.getFullYear()) {
      if (taskDate.getMonth() == today.getMonth()) {
        if (taskDate.getDate() - today.getDate() < 3) {
          return true;
        }
        return false;
      }
      return false;
    }
    return false;
  }


  /**listOfDeadlineIsNotExceeded(tasks: Task[]):Task[]{
    let tempArray = [];
    for(let task of tasks){
      if(!this.taskDeadlineIsExceeded(task)){
        tempArray.push(task);
      }else if(task.Deadline == '0001-01-01T00:00:00'){
        tempArray.push(task);
      }
    }
    return tempArray;
  }

   listOfDeadlineIsExceeded(tasks: Task[]):Task[]{
    let tempArray = [];
    for(let task of tasks){
      if(this.taskDeadlineIsExceeded(task)){
        tempArray.push(task);
      }else if(task.Deadline == '0001-01-01T00:00:00'){
        tempArray.push(task);
      }
    }
    return tempArray;
  }**/
  closingModal() {
    setTimeout(()=> {
      this.editTaskOpen = false;
    this.createTaskOpen = false;
    }, 300);
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/task-administration/task-administration-view.component.ts